import styles from './NonReturnableIcon.module.scss';
import { CatIconCancelUndo } from '@blocks-react/components/Icons/CancelUndo';

export const NonReturnableIcon = () => (
  <div className={`${styles['nonreturnable-icon-container']}`}>
    <CatIconCancelUndo color="error" iconTitle="NonReturnable" />
  </div>
);
